const devRedirectUri = "http://localhost:3000";
const prodRedirectUri = "https://orp.nitro.ey.com";
const redirectUri = process.env.NODE_ENV === 'production' ? prodRedirectUri : devRedirectUri;

const msalConfig = {
    auth: {
        clientId: "0f8e7187-1689-4197-976f-a3db6e2cdf51", // "5c135db5-3234-42a2-b4ad-a6341fa9a674",
        authority: "https://login.microsoftonline.com/ey.com", 
        redirectUri: redirectUri,
    },
    cache: {
        cacheLocation: "sessionStorage", 
        storeAuthStateInCookie: false, 
    }
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
    scopes: ["User.Read", 'profile']
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me/photo/$value"
};




export default { 
        ...msalConfig
    };